<template>
  <v-sheet
    class="full-width full-height d-flex flex-column main-container default-background"
  >
    <v-sheet
      v-if="!isMobile"
      class="text-h5 text-center d-flex align-center justify-center pa-6 flex-grow-0 role-header"
      color="primary"
      dark
      style="color:#F4F6EB"
      v-html="appDescription"
    >
    </v-sheet>
    <div
      class="flex-grow-1 d-flex justify-center"
      :class="{ 'login-container': !isMobile, 'align-center': isMobile }"
    >
      <v-card v-if="isMobile" class="text-center" :levation="0" flat>
        <div class="full-width full-height px-4 py-6">
          <div class="full-width d-flex justify-center align-center">
            <v-img
              aspect-ratio="1"
              max-width="100px"
              src="/static/img/logo.png"
              width="50%"
            ></v-img>
          </div>
          <v-card-title>
            <div class="text-center full-width text-h5 font-weight-bold">
              Chọn quyền vào hệ thống
            </div>
          </v-card-title>
          <v-card-subtitle class="pb-8 text-subtitle-2">
            {{ appName }}
          </v-card-subtitle>
          <v-card-text class="pb-0 pt-0">
            <v-btn
              v-for="role in roleRender"
              :key="role.id"
              :color="role.meta.color"
              :text-color="role.meta['text-color']"
              block
              class="text-caption text-none ma-1 my-2 font-weight-bold"
              @click="onSelectRole(role)"
            >
              {{ role.name }}
            </v-btn>
          </v-card-text>
          <v-card-text class="pb-0 pt-0"> </v-card-text>
          <div class="lg-version">
            <div class="text-caption">
              {{ copyright }}
            </div>
          </div>
        </div>
      </v-card>
      <div v-else>
        <div class="full-width full-height px-4">
          <div class="pb-5">
            <div class="full-width d-flex justify-center align-center pb-3">
              <v-img
                aspect-ratio="1"
                max-width="100px"
                src="/static/img/logo.png"
                width="50%"
              ></v-img>
            </div>
            <div class="text-center full-width text-h5 font-weight-bold pb-2">
              Chọn quyền vào hệ thống
            </div>
            <div class="text-center pb-8 text-subtitle-2">
              {{ appName }}
            </div>
          </div>

          <div class="d-flex justify-center align-center">
            <v-card
              v-for="role in roleRender"
              :key="role.id"
              rounded="xl"
              class="role-item"
              @click="onSelectRole(role)"
            >
              <v-sheet
                :color="role.meta.color"
                height="129"
                class="d-flex justify-center pa-2 px-8 align-end full-height pb-3"
              >
                <v-img
                  contain
                  :src="converUrl(role.meta.image)"
                  height="87"
                ></v-img>
              </v-sheet>
              <v-sheet height="71" class="d-flex justify-center role-name">
                <div class="font-weight-bold" style="font-size:18px">
                  {{ role.name }}
                </div>
              </v-sheet>
            </v-card>
          </div>

          <div class="lg-version">
            <div class="text-caption">
              {{ copyright }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-sheet>
</template>
<script>
import { mapGetters } from 'vuex'
import { getTitle, getCopyright, getVersion, getDescription } from '../constant'
import { convertLinkToBackEnd } from '../utils'

export default {
  components: {},
  data() {
    return {}
  },

  computed: {
    roleRender() {
      return this.currentUser.roles.filter(
        (x) => !x.meta || !x.meta.not_show_select
      )
    },
    appName() {
      return getTitle()
    },
    version() {
      return getVersion()
    },
    copyright() {
      return getCopyright()
    },
    appDescription() {
      return getDescription()
    },
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },

  created() {},

  methods: {
    converUrl(url) {
      return convertLinkToBackEnd(url)
    },
    onSelectRole(role) {
      if (!role || !role.code) return
      this.$store.commit('auth/setPrimaryRole', role)
      this.$nextTick(() => {
        let nextRoute = this.currentUser.getHomeRoute()

        this.$router.push(nextRoute)
      })
    },
  },
}
</script>
<style scoped>
.role-header {
  position: absolute;
  width: 100%;
}
.lg-version {
  position: fixed;
  bottom: 10px;
  font-weight: bold;
  left: 50%;
  transform: translateX(-50%) !important;
}
.login-container {
  background-image: url(/static/img/role-background.png);
  background-size: 100% 440px;
  background-repeat: no-repeat;
  background-position: bottom;
  padding-top: 180px;
}
.role-item:not(:first-child) {
  margin-left: 20px;
}
.role-item {
  position: relative;
  box-shadow: 0px 4px 50px rgb(225 231 237 / 67%) !important;
}
.role-item {
  width: 200px;
  height: 200px;
}
.role-name {
  padding-top: 16px;
}
@media screen and (min-width: 1440px) {
  .role-item {
    width: 250px;
    height: 250px;
  }
  .role-name {
    padding-top: 32px;
  }
}
</style>
